export default __webpack_public_path__ + "static/media/speclogo.388489ac.jpg";